import type { ParentProps } from "solid-js"
import { responsiveContainerClass } from "./responsive-container.css"

type Props = {
  class?: string
} & ParentProps

export function ResponsiveContainer(props: Props) {
  return (
    <div
      class={[responsiveContainerClass, props.class].filter(Boolean).join(" ")}
    >
      {props.children}
    </div>
  )
}
